import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class UpdateMetadataUser extends createImmutableObjectClass({
  userId: null,
  email: null,
  hubspotterId: null
}) {
  toUpdatedByInterface() {
    return {
      userId: this.userId,
      hubspotterId: this.hubspotterId
    };
  }
}